import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { Wrapper, Label, ActionsWrapper } from './styles';
import ListItemActionButton from '../../../containers/ListItem/ActionButton';
import SelectionToggler from '../../../containers/Selection/Toggler';
import UnreadBadge from '../../../containers/CoverFlow/UnreadBadge';
import DownloadStatus from '../../../containers/CoverFlow/DownloadStatus';
import ProposalStatus from '../../ListItem/ProposalStatus';
import DriveItemUtils, { ResolutionDisplayType } from '../../../utils/driveItem';
import { Api } from '../../../typings/api';

interface ItemInfoProps {
	currentDriveItem: Api.DriveItem;
	isNavigationItem: boolean;
	label: string;
}

const ItemInfo = ({ currentDriveItem, isNavigationItem, label }: ItemInfoProps) => {
	const { id, type, format, proposalStats } = currentDriveItem;
	const driveItemTypeKey = DriveItemUtils.getAssetTypeTranslationKey(type, format as Api.PublicationFormat);

	return (
		<Wrapper>
			<Label>
				<span>
					{isNavigationItem
						? <Translate value={label} />
						: DriveItemUtils.getDisplayName(currentDriveItem)
					}
				</span>
				{'|'}
				<Translate value={driveItemTypeKey} />
				{proposalStats && <ProposalStatus stats={proposalStats} />}
				<UnreadBadge id={id} />
				<DownloadStatus
					id={id}
					isRowView={false}
				/>
			</Label>
			{!isNavigationItem &&
				<ActionsWrapper>
					<ListItemActionButton
						isRowView={false}
						driveItemId={id}
						onContextualMenuHover={() => undefined}
						isActiveIcon={false}
					/>
					<SelectionToggler
						itemId={id}
						displayMode={ResolutionDisplayType.Coverflow}
					/>
				</ActionsWrapper>
			}
		</Wrapper>
	);
};

export default ItemInfo;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CoverFlow/ItemInfo/index.tsx